/* eslint-disable */
<template>
  <div class="manage-user">
    <AdminNavigation ref="navigation" indexProps="10" />
    <div class="top-panel">
      <Header />
      <div v-if="singleUser != undefined" class="header-title-section">
        <div class="header-title"><h1>{{ singleUser.id != '' ? 'Edit User' + (singleUser.name != '' ? ' - ' + singleUser.name : '') : 'Create User' }}</h1></div>
        <div class="header-sub-title">Users are required to keep track of data ownership, whether the user can login or not. Only add 'user login' where the person will authenticate into the application.</div>
      </div>
    </div>
    <div class="panel">
      <AdminUserMenu :indexProps="$route.query.id != undefined ? 0 : 1" />
      <div class="content">
        <div v-if="singleUser != undefined">
          <div class="box">
            <div class="box-heading"><span>User Details</span></div>
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">User Name</div>
                <div class="box-col box-col-right">
                  <input type="text" :class="hasError && userNameError ? 'is-invalid' : ''" v-model="singleUser.name"
                         placeholder="Please enter a user friendly name e.g. Firstname Surname - this will be used to identify the user throughout the system"
                         @blur="trimField('name')" />
                  <div v-if="hasError && userNameError" class="text-danger">{{ userNameError }}</div>
                </div>
              </div>
              <div class="box-row">
                <div class="box-col box-col-left">Role</div>
                <div class="box-col box-col-right">
                  <select class="textbox" :class="hasError && roleError ? 'is-invalid' : ''" v-model="singleUser.type">
                    <option hidden value="0">Select ...</option>
                    <option v-for="(role, index) in roles" :value="role.id">{{ role.name }}</option>
                  </select>
                  <div v-if="hasError && roleError" class="text-danger">{{ roleError }}</div>
                </div>
              </div>
              <div class="box-row" v-if="singleUser.id != '' && this.singleUser.typeName !== 'PracticeManager'" :class="singleUser.id != '' ? 'disabled-element' : ''">
                <div class="box-col box-col-left">Specialist</div>
                <div class="box-col box-col-right">
                  <select class="textbox" v-model="singleUser.specialistId" :disabled="singleUser.id != ''">
                    <option  v-if="singleUser.id == ''" value="0">Select ...</option>
                    <option  v-else></option>
                    <option v-for="(specialist, index) in specialists" :value="specialist.id">{{ specialist.fullName }}</option>
                  </select>
                </div>
              </div>
              <div class="box-row"  v-if="singleUser.id != '' && this.singleUser.typeName !== 'PracticeManager'" :class="singleUser.id != '' ? 'disabled-element' : ''">
                <div class="box-col box-col-left">Client</div>
                <div class="box-col box-col-right">
                  <select class="textbox" v-model="singleUser.clientId" :disabled="singleUser.id != ''">
                    <option  v-if="singleUser.id == ''" value="0">Select ...</option>
                    <option  v-else></option>
                    <option v-for="(client, index) in clients" :value="client.id">{{ client.name }}</option>
                  </select>
                </div>
              </div>
              <div class="box-row" :class="!isEditable && singleUser.typeName !== 'PracticeManager' ? 'disabled-element' : ''">
                <div class="box-col box-col-left">User Login?</div>
                <div class="box-col box-col-right row-item">
                   <input type="checkbox" :checked="singleUser.status" :disabled="!isEditable" v-model="singleUser.status" />
                    <v-btn v-if="showResend" class="ml-10 col-center-content" :disabled="!isEditable && singleUser.typeName !== 'PracticeManager'" style="background-color:#C4C4C4;color:#6686B6F" @click="reSendInvitation()"> Resend Invite</v-btn>
                </div>
              </div>
              <div class="box-row" :class="!isEditable ? 'disabled-element' : ''">
                <div class="box-col box-col-left">Email</div>
                <div class="box-col box-col-right">
                  <input type="text" :class="hasError && emailError ? 'is-invalid' : ''" v-model="singleUser.email" :disabled="!isEditable"
                         placeholder="Please enter the user’s email address - this will be used to login"
                         @blur="trimField('email')" />
                  <div v-if="hasError && emailError" class="text-danger">{{ emailError }}</div>
                </div>
              </div>
              <div class="box-row" :class="!isEditable ? 'disabled-element' : ''">
                <div class="box-col box-col-left">Mobile Phone</div>
                <div class="box-col box-col-right">
                  <input type="text" class="w-50" :class="hasError && phoneError ? 'is-invalid' : ''" v-model="singleUser.phone" :disabled="!isEditable"
                         placeholder="+61 followed by 9 digits (12 characters)"
                         @blur="normalizePhoneField" />
                  <div class="text-danger" v-if="hasError && phoneError">{{ phoneError }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="alert alert-success hidden-element">
            <a class="close" title="close">×</a>
            <b>Success:</b> {{ successMessage }}
          </div>
          <div class="alert alert-danger hidden-element">
            <a class="close" title="close">×</a>
            <b>Error:</b> {{ errorMessage }}
          </div>

          <div class="icon-group right-float-element">
            <v-btn dark @click="save">Save</v-btn>
          </div>
        </div>
        <div v-else>This user not found.</div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import AdminUserMenu from '@/components/AdminUserMenu'
  import Header from '@/components/Header'

  export default {
    name: 'AdminManageUser',
    components: {
      AdminNavigation,
      AdminUserMenu,
      Header,
    },
    data() {
      return {
        hasError: false,
        successMessage: "",
        errorMessage: "Please correct the errors shown above and try again.",
        loaded: false,
        showResend: false,
        isEditable: true,
        singleUser: utilities.initUser(),

        roles: [],
        specialists: [],
        clients: [],
        users: [],
        userParam: {
          pageNum: 1,
          pageSize: 10,
          EmailAddress: null
        },
      }
    },
    watch: {
      singleUser: {
        handler(value) {
          if (this.loaded) this.$store.dispatch('setNewObject', value)
        },
        deep: true,
      },
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      /** Excel: User name 1–100 chars — letters, space, hyphen, apostrophe (same as client contact person name). */
      userNameError() {
        return utilities.getClientContactPersonNameError(this.singleUser.name, 'User name')
      },
      roleError() {
        const t = this.singleUser.type
        if (t === '' || t === null || t === undefined || Number(t) === 0) {
          return 'Role is required.'
        }
        return ''
      },
      /** Excel: Phone exactly 12 characters (+61 + 9 digits). */
      phoneError() {
        const normalized = utilities.normalizeAuPhoneInput(this.singleUser.phone)
        if (!normalized) {
          return 'Phone is required.'
        }
        return utilities.getClientContactPhoneAu12Error(normalized)
      },
      /** Excel: Email 1–100 chars — allowed charset + standard email. */
      emailError() {
        return utilities.getClientContactEmailError(this.singleUser.email, 'Email', true)
      },
    },
    methods: {
      trimField(prop) {
        const v = this.singleUser[prop]
        if (v === undefined || v === null) return
        this.singleUser[prop] = String(v).trim()
      },
      normalizePhoneField() {
        if (!this.isEditable) return
        this.singleUser.phone = utilities.normalizeAuPhoneInput(this.singleUser.phone)
      },
      sanitizeBeforeSave() {
        this.trimField('name')
        this.trimField('email')
        this.singleUser.phone = utilities.normalizeAuPhoneInput(this.singleUser.phone)
      },
      async save() {
        this.sanitizeBeforeSave()
        if (this.userNameError || this.roleError || this.emailError || this.phoneError) {
          this.hasError = true
          utilities.showAlert(".alert-danger")
          return false
        }
        this.hasError = false

        if (this.singleUser.id != '') {
          await this.editUser()
        } else {
          await this.addUser()
        }
      },
      postUser() {
        var params = {
          UserName: this.singleUser.name,
          UserRoleID: this.singleUser.type,
          UserStatus: utilities.convertBoolToNum(this.singleUser.status),
          // SpecialistID: this.singleUser.specialistId,
          // ClientID: this.singleUser.clientId != 0 ? this.singleUser.clientId : "",
          EmailAddress: this.singleUser.email,
          Mobile: utilities.updateMobileCode(utilities.validatePhonenumber(this.singleUser.phone)),
        }

        var callback = (response) => {
          this.singleUser.id = response
        }
        return utilities.postUser(params, callback)
      },

      async reSendInvitation() {
        this.sanitizeBeforeSave()
        if (this.phoneError) {
          this.hasError = true
          utilities.showAlert(".alert-danger")
          return false
        }
        this.hasError = false
        await this.$store.dispatch('loading/setLoadComponent', true)
        var mobile = utilities.updateMobileCode(utilities.validatePhonenumber(this.singleUser.phone))
        if(mobile.charAt(0) == '0') {
          mobile = mobile.substring(1)
        }

        var result = await utilities.postResendInvite(this.singleUser.id)
        if (result) {
          this.successMessage = 'Invitation resent'
          utilities.showAlert(".alert-success")
        }
        this.$store.dispatch('loading/setLoadComponent', false)
      },

      putUser() {
        var params = {
          UserName: this.singleUser.name,
          UserRoleID: this.singleUser.type,
          UserStatus: utilities.convertBoolToNum(this.singleUser.status),
          EmailAddress: this.singleUser.email,
          Mobile: utilities.updateMobileCode(utilities.validatePhonenumber(this.singleUser.phone)),
        }

        return utilities.putUser(this.singleUser.id, params)
      },

      async addUser() {
        await this.$store.dispatch("loading/setLoadComponent", true)

        var result = await this.postUser()
        if (result) {
          if (this.singleUser.status) {
            this.showResend = true
          } else {
            this.showResend = false
          }
          this.successMessage = "User successfully created and invited to Red Health Online."
          utilities.showAlert(".alert-success")

          setTimeout(() => {
            window.history.replaceState({}, document.title, location.pathname + '?id=' + this.singleUser.id)
            this.loadUser()
          }, 2000)
        }

        await this.$store.dispatch("loading/setLoadComponent", false)
      },
      async editUser() {
        await this.$store.dispatch("loading/setLoadComponent", true)

        var result = await this.putUser()
        if (result) {
          if (this.singleUser.status) {
            this.showResend = true
          } else {
            this.showResend = false
          }
          utilities.clearChangingObject()
          this.successMessage = "User updated successfully."
          utilities.showAlert(".alert-success")
          setTimeout(() => {
            this.loadUser()
          }, 2000)
        }

        await this.$store.dispatch("loading/setLoadComponent", false)
      },
      async loadUser() {
        var id = (this.$route.query != undefined && this.$route.query.id != undefined) ? this.$route.query.id : ""
        if(id != '') {
          this.singleUser = await utilities.getUserById(id)
          if (this.singleUser.status) {
            this.showResend = true
          } else {
            this.showResend = false
          }
          this.oldUser = _.cloneDeep(this.singleUser)
          await this.$store.dispatch('setOriginalObject', this.singleUser)
          await this.$store.dispatch('setNewObject', this.singleUser)
        }
      },
      async loadData() {
        var role = await utilities.getUserRoles()

        if (this.singleUser.id == '' || this.singleUser.typeName == "RHFinancialAdmin" || this.singleUser.typeName == "SuperAdmin" || this.singleUser.typeName == "RHAdmin" ) {
          this.isEditable = true
          role.map((x) => {
            if (x.name === "RHFinancialAdmin" || x.name === "SuperAdmin" ||x.name === "RHAdmin") {
              this.roles.push(x)
            }
          })
        } else if (this.singleUser.typeName == 'Client' || this.singleUser.typeName == 'BranchAdmin') {
          this.isEditable = false
          role.map((x) => {
            if (x.name == "BranchAdmin" || x.name == "Client") {
              this.roles.push(x)
            }
          })
          this.clients = await utilities.getClients()
        } else if (this.singleUser.typeName == 'Specialist') {
          this.isEditable = false
          role.map((x) => {
            if (x.name == "Specialist") {
              this.roles.push(x)
            }
          })
          this.specialists = await utilities.getSpecialists()
        } else if (this.singleUser.typeName == 'PracticeManager') {
          this.isEditable = false
          role.map((x) => {
            if (x.name == "PracticeManager") {
              this.roles.push(x)
            }
          })
        }

      }
    },
    mounted() {
      this.$watch(
          () => this.user,
          async (newVal, oldVal) => {
            console.log(newVal)
            if (newVal && newVal.id) {
              await this.$store.dispatch('loading/setLoadComponent', true)
              if (this.user.type !== 6) {
                this.$router.go(-1)
                return false
              }
              await this.loadUser()
              await this.loadData()
              this.loaded = true
              await this.$store.dispatch('loading/setLoadComponent', false)
            }
          },
          { immediate: true, deep: true }
      )
    },
  }
</script>
